import {
  BooleanCons,
  NumberCons,
  PaymentTypeInfo,
  StringConst,
  TypeBBVAPayments,
} from 'src/app/constants/const';

export class PaymentInformation {
  clabe: string;
  bank: string;
  receivingAccountNumber: string;
  receivingAccountBank: string;
  object: PaymentTypeInfo;
  type: string;
  serviceName: string;
  storeName: string;
  reference: string;
  cardName: string;
  expMonth: string;
  expYear: string;
  authCode: string;
  cardLastNumbers: string;
  brand: string;
  cardIssuer: string;
  accountType: string;
  country: string;
  expiresAt: Date;
  barcodeUrl: string;
  methodImage: string;
  isCaduced: boolean;
  cardId: string;
  monthlyInstallments?: number | null;
  monthlyAmount?: number | null;
  constructor() {
    this.clabe = StringConst.empty;
    this.bank = StringConst.empty;
    this.receivingAccountNumber = StringConst.empty;
    this.receivingAccountBank = StringConst.empty;
    this.object = PaymentTypeInfo.default;
    this.type = StringConst.empty;
    this.serviceName = StringConst.empty;
    this.storeName = StringConst.empty;
    this.reference = StringConst.empty;
    this.cardName = StringConst.empty;
    this.expMonth = StringConst.empty;
    this.expYear = StringConst.empty;
    this.authCode = StringConst.empty;
    this.cardLastNumbers = StringConst.empty;
    this.brand = StringConst.empty;
    this.cardIssuer = StringConst.empty;
    this.accountType = StringConst.empty;
    this.country = StringConst.empty;
    this.expiresAt = new Date();
    this.barcodeUrl = StringConst.empty;
    this.methodImage = StringConst.empty;
    this.isCaduced = BooleanCons.false;
    this.cardId = StringConst.empty;
  }
}
